// @flow

import prefersColorScheme from './prefersColorScheme';
import colorSchemes, { type ColorScheme } from './colorSchemes';

export default prefersColorScheme;

export { colorSchemes };
export type { ColorScheme };
